export enum NotificationType {
  Error = 1,
  Warning = 2,
  Success = 3,
  Mistake = 4,
}
